/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Ladder from 'solis/claude/logic/galaxy/ladder';

import ScoreCard from 'solis/claude/score/card';


const LADDERS =
[
  { field: 'territory', label: 'Territory Score' },
  { field: 'value',     label: 'Development Score' },
  { field: 'authority', label: 'Power Score' },
];


export default () =>
{
  const galaxy = use(Galaxy);

  const ladder = new Ladder(galaxy);

  const user = galaxy.getCurrentAccount().cass.id;

  return (
    <Flex direction = 'column' gap = '3'>
      {LADDERS.map(({ field, label }) => <ScoreCard key = {field} label = {label} scores = {ladder.getScoresAround(field, user)} user = {user} />)}
    </Flex>
  );
};
